import { useMemo } from "react";

// 상태 코드와 상태명을 상호 매핑하는 헬퍼 훅
// processingMap은 한 번만 생성해 재렌더 시 참조가 바뀌지 않도록 useMemo로 감싼다.
function useGetStatusMessage() {
    const processingMap = useMemo(() => {
        const map = new Map<string, string>();

        // 상태 그룹 코드 -> 상태명
        map.set("SG001", "안전");
        map.set("SG002", "주의");
        map.set("SG003", "경보");
        map.set("SG004", "점검");

        // STN 상태 코드 -> 상태명
        map.set("0", "안전운행");
        map.set("1", "폭염주의");
        map.set("2", "폭염경보");
        map.set("3", "강풍주의");
        map.set("4", "강풍경보");
        map.set("5", "미끄럼주의");
        map.set("6", "미끄럼경보");
        map.set("7", "살얼음주의");
        map.set("8", "살얼음경보");
        map.set("9", "눈 감지");

        // 상태명 -> STN 상태 코드
        map.set("안전운행", "안전");
        map.set("폭염주의", "주의");
        map.set("폭염경보", "경보");
        map.set("강풍주의", "주의");
        map.set("강풍경보", "경보");
        map.set("미끄럼주의", "주의");
        map.set("미끄럼경보", "경보");
        map.set("살얼음주의", "주의");
        map.set("살얼음경보", "경보");
        map.set("눈 감지", "경보");
        map.set("점검", "점검");

        // 상태명 -> 상태 그룹 코드
        map.set("안전", "SG001");
        map.set("주의", "SG002");
        map.set("경보", "SG003");
        map.set("점검", "SG004");

        return map;
    }, []);

    return { processingMap, isEmpty: false };
}

export default useGetStatusMessage;
